import AboutTemplate from "../../components/about/AboutTemplate";
import Page from "../Page";
import { Typography } from "@mui/material";
import Section from "../../components/about/Section";
import ResponsiveImage from "../../components/about/ResponsiveImage";

const TimeBlocks = () => {
  return (
    <Page className="about-page time-blocks-page" pageKey="time-blocks">
      <AboutTemplate>
        <Typography variant="h1">Time Blocks</Typography>

        <Section>
          <Typography variant="p1">
            Time blocks are general-purpose blocks that you can use to schedule
            anything in your day. They are the simplest type of block in the Day
            Planner.
          </Typography>
          <ResponsiveImage
            pageKey="timeBlocks"
            imageName="time-block"
            size="large"
          />
        </Section>

        <Section title="Creating a time block">
          <Typography variant="p1">
            When inserting a new block, select <strong>"Time Block"</strong> as
            the block type. You'll be asked to provide:
          </Typography>
          <Typography variant="p1">
            <strong>Name</strong> - A short label for the block, such as "Lunch
            break" or "Deep work session".
          </Typography>
          <Typography variant="p1">
            <strong>Colour</strong> - Choose a colour to visually distinguish
            the block on your timeline.
          </Typography>
          <Typography variant="p1">
            <strong>Time range</strong> - Set the start and end times for the
            block. The times will snap to your chosen time interval.
          </Typography>
          <ResponsiveImage
            pageKey="timeBlocks"
            imageName="create-time-block"
            size="medium"
          />
        </Section>

        <Section title="Editing a time block">
          <Typography variant="p1">
            Click on an existing time block to select it. The Edit Block panel
            will appear, allowing you to change the block's name, colour, or
            time range.
          </Typography>
          <ResponsiveImage
            pageKey="timeBlocks"
            imageName="edit-time-block"
            size="medium"
          />
        </Section>

        <Section title="When to use time blocks">
          <Typography variant="p1">
            Time blocks are ideal for scheduling general events and routines
            that aren't linked to a specific task or activity - things like
            lunch breaks, commuting, meetings, or free time.
          </Typography>
          <Typography variant="p1">
            If you want to link a block to a reusable activity, consider using
            an Activity Block instead. If you want to dedicate time to specific
            tasks from your stack, use a Task Block.
          </Typography>
        </Section>
      </AboutTemplate>
    </Page>
  );
};

export default TimeBlocks;
